import { ref } from 'vue';
import { defineStore } from 'pinia';

import { SemboDate } from '@libs/sembo-dates';
import type { HotelBookableOptionWithRoomsAndDate } from '@libs/trip-planner-interfaces';
import { getAffiliateCookieData } from '@libs/cookie';
import { arrayContainsAllValues } from '@libs/utils';

import { useCustomerFlowStore } from '../customerFlowStore';
import { CustomerFlow } from '../../models';

export enum MetaSources {
  MetaHotel = 'Meta hotel',
}

export const useMetaStore = defineStore('MetaStore', () => {
  const customerFlowStore = useCustomerFlowStore();

  // State
  const metaAffiliateId = ref<string>();
  const metaClientId = ref<string>();
  const metaDate = ref<Date>();
  const metaHotelCode = ref<string>();
  const metaRoom = ref<string[]>();
  const metaSource = ref<string>();

  // Actions
  function setMetaInfo(metaRooms?: string[], initialDate?: Date): void {
    const affiliateCookieData = getAffiliateCookieData();

    metaRoom.value = metaRooms;
    metaAffiliateId.value =
      affiliateCookieData?.affiliateCookieParams.AffiliateId;
    metaClientId.value = affiliateCookieData?.affiliateCookieParams.ClientId;
    metaDate.value = initialDate;
    metaSource.value = affiliateCookieData?.affiliateCookieParams.utm_medium;

    if (metaSource.value === MetaSources.MetaHotel) {
      customerFlowStore.setCustomerFlow(CustomerFlow.MetaHotel);
    }
  }

  // Getters
  function stayIsFromMeta(stay: HotelBookableOptionWithRoomsAndDate): boolean {
    const roomsCodes: string[] = stay.rooms.map((room) => room.roomCode);
    return (
      new SemboDate(metaDate.value).isSameDay(stay.date) &&
      metaHotelCode.value === stay.code &&
      arrayContainsAllValues(metaRoom.value ?? [], roomsCodes)
    );
  }

  return {
    //State
    metaAffiliateId,
    metaClientId,
    metaDate,
    metaHotelCode,
    metaRoom,

    // Actions
    setMetaInfo,

    // Getters
    stayIsFromMeta,
  };
});
